/* ==========================================================================
   Revalia Tart Cherry — product page behavior
   Vanilla port of the approved design's Component logic. No framework.
   Idempotent: safe to load from multiple sections and to re-run in the
   theme editor (shopify:section:load).
   ========================================================================== */
(function () {
  'use strict';

  /* ---------------- helpers ---------------- */
  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduced = function () {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  };

  /* ---------------- 1. bundle picker -> price ---------------- */
  function money(v) {
    var n = parseFloat(v);
    if (isNaN(n)) return '';
    return '$' + n.toFixed(2);
  }

  function initBundles(root) {
    var picker = $('[data-tce-bundles]', root);
    if (!picker) return;

    var cards   = $$('[data-tce-bundle]', picker);
    var priceEl = $('[data-tce-cart-price]', root);
    var compEl  = $('[data-tce-cart-compare]', root);
    var varEl   = $('[data-tce-variant]', root);
    if (!cards.length) return;

    function select(card) {
      cards.forEach(function (c) {
        var on = c === card;
        c.classList.toggle('is-selected', on);
        c.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      if (priceEl) priceEl.textContent = money(card.getAttribute('data-price'));
      if (compEl) {
        var cmp = money(card.getAttribute('data-compare'));
        compEl.textContent = cmp;
        compEl.style.display = cmp ? '' : 'none';
      }
      // real Shopify add-to-cart: point the form at this bundle's variant
      if (varEl) {
        var vid = card.getAttribute('data-variant');
        if (vid) varEl.value = vid;
      }
    }

    cards.forEach(function (card) {
      if (card.dataset.tceBound) return;
      card.dataset.tceBound = '1';
      card.addEventListener('click', function () { select(card); });
    });

    // default = the block marked selected, else the second (design default), else first
    var def = picker.querySelector('[data-tce-bundle][data-default="true"]') || cards[1] || cards[0];
    select(def);
  }

  /* ---------------- 1b. Kaching Bundles -> CTA compare-at price ----------------
     The Kaching app owns the offer and writes the selected bundle's price into
     the CTA, but it never fills the compare-at. Mirror the selected bundle's
     strikethrough price ("was" price) onto the button. Bundles without one
     (e.g. Buy One) simply hide it. No-ops if the app isn't on the page. */
  function initKachingCompare() {
    var cmp = document.querySelector('[data-tce-cart-compare]');
    if (!cmp) return;

    var kb = document.querySelector('kaching-bundle');
    if (!kb) {
      // the app injects asynchronously — wait for it, then bind (give up after ~20s)
      if (window.__tceKachingWait) return;
      window.__tceKachingWait = true;
      var tries = 0;
      var iv = setInterval(function () {
        if (document.querySelector('kaching-bundle')) {
          clearInterval(iv);
          window.__tceKachingWait = false;
          initKachingCompare();
        } else if (++tries > 40) {
          clearInterval(iv);
          window.__tceKachingWait = false;
        }
      }, 500);
      return;
    }
    if (kb.dataset.tceCmpBound) return;
    kb.dataset.tceCmpBound = '1';

    var desired = '';

    var read = function () {
      var sel  = kb.querySelector('.kaching-bundles__bar--selected');
      var full = sel && sel.querySelector('.kaching-bundles__bar-full-price');
      return full ? full.textContent.trim() : '';
    };

    var sync = function () {
      desired = read();
      if (cmp.textContent.trim() !== desired) cmp.textContent = desired;
      cmp.style.display = desired ? '' : 'none';
    };

    sync();

    // re-sync whenever the app re-renders or the selection changes
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(sync, 60);
    }).observe(kb, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });

    kb.addEventListener('click', function () { setTimeout(sync, 80); });

    // if the app later clobbers the span, put our value back (no loop: only on mismatch)
    new MutationObserver(function () {
      if (cmp.textContent.trim() !== desired) {
        cmp.textContent = desired;
        cmp.style.display = desired ? '' : 'none';
      }
    }).observe(cmp, { childList: true, characterData: true, subtree: true });
  }

  /* ---------------- 2. arrival date (today + 5 days) ---------------- */
  function initArrival(root) {
    var els = $$('[data-tce-arrival]', root);
    if (!els.length) return;
    var offset = 5;
    els.forEach(function (el) {
      var o = parseInt(el.getAttribute('data-tce-arrival'), 10);
      var days = isNaN(o) ? offset : o;
      var d = new Date(Date.now() + days * 86400000);
      var month = d.toLocaleDateString('en-US', { month: 'long' });
      var day = d.getDate();
      var s = (day % 10 === 1 && day !== 11) ? 'st'
            : (day % 10 === 2 && day !== 12) ? 'nd'
            : (day % 10 === 3 && day !== 13) ? 'rd' : 'th';
      el.textContent = month + ' ' + day + s;
    });
  }

  /* ---------------- 3. carousel ---------------- */
  var carousel = { index: 0, count: 0 };

  function railCenter(i) {
    var rail = $('[data-tce-rail]');
    if (!rail) return;
    var child = rail.children[i];
    if (!child) return;
    var target = child.offsetLeft - rail.clientWidth / 2 + child.clientWidth / 2;
    var max = rail.scrollWidth - rail.clientWidth;
    rail.scrollTo({ left: Math.max(0, Math.min(target, max)), behavior: 'smooth' });
  }

  function changeSlide(i) {
    var track = $('[data-tce-track]');
    var thumbs = $$('[data-tce-thumb]');
    if (!track) return;
    var n = carousel.count || thumbs.length;
    if (!n) return;
    i = ((i % n) + n) % n;
    carousel.index = i;
    track.style.transform = 'translateX(' + (-100 * i) + '%)';
    thumbs.forEach(function (t, k) {
      t.classList.toggle('is-active', k === i);
      t.setAttribute('aria-selected', k === i ? 'true' : 'false');
    });
    railCenter(i);
  }

  function initCarousel(root) {
    var main = $('[data-tce-carousel]', root);
    if (!main) return;
    var thumbs = $$('[data-tce-thumb]', root);
    carousel.count = thumbs.length;
    carousel.index = 0;

    thumbs.forEach(function (t, i) {
      if (t.dataset.tceBound) return;
      t.dataset.tceBound = '1';
      t.addEventListener('click', function () { changeSlide(i); });
    });
    changeSlide(0);
  }

  // Gestures are bound ONCE at document level and delegated via closest(),
  // so they survive section re-render in the theme editor (per spec).
  function initGestures() {
    if (window.__tceGestures) return;
    window.__tceGestures = true;

    var THRESHOLD = 40;   // px of horizontal travel needed to change slide
    var LOCK = 8;         // px of travel before we commit to an axis
    var inCarousel = function (t) { return t && t.closest && t.closest('[data-tce-carousel]'); };
    var x0 = null, y0 = null, axis = null, mx0 = null;

    var commit = function (dx) {
      if (dx < -THRESHOLD) changeSlide(carousel.index + 1);
      else if (dx > THRESHOLD) changeSlide(carousel.index - 1);
    };

    document.addEventListener('touchstart', function (e) {
      if (!inCarousel(e.target)) { x0 = null; return; }
      x0 = e.touches[0].clientX;
      y0 = e.touches[0].clientY;
      axis = null; // undecided until the finger clearly moves one way
    }, { passive: true });

    // Non-passive so preventDefault actually takes effect.
    // Single-axis lock: the FIRST decisive movement decides the gesture, and it
    // cannot flip mid-swipe. Horizontal -> we drive the carousel and block page
    // scroll. Vertical -> the page scrolls normally and the carousel never moves.
    document.addEventListener('touchmove', function (e) {
      if (x0 === null) return;
      var dx = e.touches[0].clientX - x0;
      var dy = e.touches[0].clientY - y0;

      if (!axis && (Math.abs(dx) > LOCK || Math.abs(dy) > LOCK)) {
        axis = Math.abs(dx) > Math.abs(dy) ? 'h' : 'v';
      }
      // only swallow the gesture once it's clearly horizontal
      if (axis === 'h' && e.cancelable) e.preventDefault();
    }, { passive: false });

    document.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      // a vertical (or undecided) gesture must NOT move the carousel
      if (axis === 'h') commit(e.changedTouches[0].clientX - x0);
      x0 = null; y0 = null; axis = null;
    }, { passive: true });

    document.addEventListener('mousedown', function (e) {
      var el = inCarousel(e.target);
      if (!el) { mx0 = null; return; }
      mx0 = e.clientX;
      el.classList.add('is-grabbing');
      e.preventDefault();
    });

    document.addEventListener('mouseup', function (e) {
      if (mx0 === null) return;
      commit(e.clientX - mx0);
      mx0 = null;
      var el = $('[data-tce-carousel]');
      if (el) el.classList.remove('is-grabbing');
    });

    document.addEventListener('dragstart', function (e) {
      if (inCarousel(e.target)) e.preventDefault();
    });
  }

  /* ---------------- 4. accordions (animated, one-open-at-a-time) ---------------- */
  function closeAcc(d) {
    var s = d.querySelector('summary');
    var c = s && s.nextElementSibling;
    if (!c) return;
    c.style.height = c.scrollHeight + 'px';
    requestAnimationFrame(function () {
      c.style.height = '0px';
      c.style.opacity = '0';
    });
    var done = function () { d.removeAttribute('open'); };
    c.addEventListener('transitionend', done, { once: true });
  }

  function initAccordions(root) {
    $$('details[data-tce-acc]', root).forEach(function (d) {
      var summary = d.querySelector('summary');
      var content = summary && summary.nextElementSibling;
      if (!summary || !content) return;

      content.style.overflow = 'hidden';
      content.style.transition = 'height 0.38s cubic-bezier(0.4,0,0.2,1), opacity 0.3s ease';
      if (!d.hasAttribute('open')) { content.style.height = '0px'; content.style.opacity = '0'; }
      else { content.style.height = 'auto'; content.style.opacity = '1'; }

      if (d.dataset.tceBound) return;
      d.dataset.tceBound = '1';

      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (d.hasAttribute('open')) {
          closeAcc(d);
        } else {
          // exclusive: close any open sibling in the same group
          var group = d.parentElement;
          if (group) {
            $$(':scope > details[open]', group).forEach(function (other) {
              if (other !== d) closeAcc(other);
            });
          }
          d.setAttribute('open', '');
          content.style.opacity = '1';
          content.style.height = content.scrollHeight + 'px';
          var done = function () { if (d.hasAttribute('open')) content.style.height = 'auto'; };
          content.addEventListener('transitionend', done, { once: true });
        }
      });
    });
  }

  /* ---------------- 5. scroll reveal ---------------- */
  function initReveal(root) {
    if (reduced() || !('IntersectionObserver' in window)) return;
    var sections = $$('[data-tce-reveal]', root);
    if (!sections.length) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('tce-reveal-in');
          io.unobserve(en.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    sections.forEach(function (s) {
      if (s.dataset.tceRevealBound) return;
      s.dataset.tceRevealBound = '1';
      var r = s.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.9) return; // already in view -> leave visible
      s.classList.add('tce-reveal');
      io.observe(s);
    });
  }

  /* ---------------- 6. mobile sticky CTA ---------------- */
  function initStickyReveal() {
    var bar = $('[data-tce-sticky]');
    var atc = $('.tce-cta');
    if (!bar || bar.dataset.tceRevealBound) return;

    // No ATC to track (or no IO support) -> just show it, never trap the user.
    if (!atc || !('IntersectionObserver' in window)) {
      bar.classList.add('is-visible');
      return;
    }
    bar.dataset.tceRevealBound = '1';

    // Show only once the real Add-to-Cart button has scrolled ABOVE the viewport.
    // (Not intersecting + below the fold = user hasn't reached it yet -> stay hidden.)
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var scrolledPast = !en.isIntersecting && en.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', scrolledPast);
      });
    }, { threshold: 0 }).observe(atc);
  }

  function initSticky() {
    if ($('[data-tce-sticky]')) document.body.classList.add('tce-has-sticky');
    initStickyReveal();

    // Scroll the real Add-to-Cart button into the middle of the screen.
    // A plain #anchor would jump it to the very top, and Horizon scrolls an
    // inner .page-wrapper, so scrollIntoView (which walks the scroll parents)
    // is the reliable way. Only hijack in-page (#) links.
    var link = $('[data-tce-sticky] a');
    if (!link || link.dataset.tceBound) return;
    link.dataset.tceBound = '1';

    link.addEventListener('click', function (e) {
      var href = link.getAttribute('href') || '';
      if (href.charAt(0) !== '#') return; // custom URL -> let it through
      var atc = $('.tce-cta');
      if (!atc) return;
      e.preventDefault();
      atc.scrollIntoView({
        behavior: reduced() ? 'auto' : 'smooth',
        block: 'center',
        inline: 'nearest',
      });
    });
  }

  /* ---------------- 7. add to cart (AJAX) ----------------
     Why this exists: the Kaching Bundles app works the way every normal Shopify
     theme does — it intercepts the theme's cart-add *AJAX* call and rewrites the
     payload into the full bundle (n bottles + the free gift).

     Our form was doing a NATIVE POST, which the app cannot intercept. Result:
     the app added the bundle AND the raw form posted the bottles again — 3 + 3 = 6.

     So we submit via fetch(), exactly like a theme would. The app intercepts it,
     rewrites it to the correct bundle, and the cart gets ONE clean add. We then
     send the shopper to checkout (or the cart) ourselves.
     Falls back to the plain native post if fetch/JS is unavailable. */
  function initAtcForm() {
    var form = $('[data-tce-atc-form]');
    if (!form || !window.fetch || form.dataset.tceAtcBound) return;
    form.dataset.tceAtcBound = '1';

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var btn = form.querySelector('.tce-cta');
      if (btn) btn.disabled = true; // no double-click double-add

      var dest = form.getAttribute('data-tce-checkout') === 'true' ? '/checkout' : '/cart';
      var data = new FormData(form);
      data.delete('return_to'); // not used by the AJAX endpoint; we navigate ourselves

      var go = function () { window.location.href = dest; };

      fetch('/cart/add.js', {
        method: 'POST',
        body: data,
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        credentials: 'same-origin',
      })
        .then(go)
        .catch(function () {
          // network failure -> fall back to a normal submit so the shopper isn't stuck
          if (btn) btn.disabled = false;
          form.submit();
        });
    });
  }

  /* ---------------- boot ---------------- */
  function init(root) {
    root = root || document;
    initBundles(root);
    initKachingCompare();
    initAtcForm();
    initArrival(root);
    initCarousel(root);
    initAccordions(root);
    initReveal(root);
    initSticky();
    initGestures();
  }

  function boot() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); });
    } else {
      init(document);
    }
  }

  if (!window.__tceInit) {
    window.__tceInit = true;
    boot();
    // theme editor: re-init the section that just re-rendered
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
    document.addEventListener('shopify:section:unload', function () {
      document.body.classList.toggle('tce-has-sticky', !!$('[data-tce-sticky]'));
    });
  }
})();
